export { default } from 'ember-intl/-private/utils/missing-message';
